import {Orders} from './order-model';

export interface TimeControlEntry {
    rowID: string;
    employeeID: number;
    mandantID: string;
    objectNumber: string;
    objectID: string | null;
    description: string;
    costCenterID: number;
    expenseID: number;
    entryDate: string;
    originalStartTime: string | null;
    startTime: string | null;
    originalEndTime: string | null;
    endTime: string | null;
    originalTimeAmount: number;
    timeAmount: null;
    expenseAmount: number;
    expenseRate: number;
    note: string;
    workplace: string;
    sortorder?: number;
    controlled?: boolean;
    differencesExists?: boolean;
    readyForExport: boolean;
    exported: boolean;
    deleted: boolean;
}

export interface CostCenter {
    arbeitsOrt: string;
    costCenterID: number;
    description: string;
    kostenStelle: string;
    text: string;
    obligatoryWorkplace: boolean;

}

export const EmptyCostCenter = (): CostCenter => ({
    arbeitsOrt: '', costCenterID: 0, description: '', kostenStelle: '', text: '', obligatoryWorkplace: false
});

export interface Expense {
    amountOne: string;
    betrag: number;
    description: string;
    expenseID: number;
    menge: number;
    rate: string;
}

export const EmptyExpense = (): Expense => ({
    amountOne: '', betrag: 0, description: '', expenseID: 0, menge: 0, rate: '',
});

export interface Order {
    lastname: string;
    street1: string;
    city: string;
    phone: string;
    phone03: string;
    archAnspLastname: string;
    archAnspFirstname: string;
    archAnspPhone: string;
    archAnspPhone03: string;
    objectID: string;
    objectNumber: string;
    description: string;
    note4: string;
    scanData: string;
    liefLastname: string;
    liefPhone: string;
    liefPhone03: string;
    liefStreet1: string;
    liefCity: string;
}

export const EmptyOrder = (): Orders => ({
    objectNumber: '',
    objectID: '',
    objectSummary: '',
    description: '',
    lastname: '',
    firstname: '',
    street1: '',
    city: '',
    zip: 0,
    phone: '',
    phone03: '',
    anspLastname: '',
    anspFirstname: '',
    anspPhone: '',
    anspPhone03: '',
    archLastname: '',
    archFirstname: '',
    archPhone: '',
    archPhone03: '',
    archStreet1: '',
    archCity: '',
    archZip: '',
    archAnspLastname: '',
    archAnspFirstname: '',
    archAnspPhone: '',
    archAnspPhone03: '',
    note4: '',
    dateOfDelivery: '',
    dateOfDeliveryOK: 0,
    orderDay: null,
    startTime: null,
    endTime: null,
    notes: null,
    fK_AutoCostCenter: 0,
    employeeID: 0,
    liefLastname: '',
    liefFirstname: '',
    liefPhone: '',
    liefPhone03: '',
    liefStreet1: '',
    liefCity: '',
    liefZip: '',
    liefAnspLastname: '',
    liefAnspFirstname: '',
    liefAnspPhone: '',
    liefAnspPhone03: '',
    status: 0,
    recomendedWorkPlace: '',
});

export interface OrderData {
    auftrag: Orders;
    kostenStelle?: CostCenter;
    start: string;
    end: string;
    total: number;
    spesen: Expense;
    menge: number;
    betrag: string;
    notizen: string;
    scanData: string;
    editTimeEntryDate?: string;
    editTimeEntryRowID?: string;
    isEditMode?: boolean;
}

export const EmptyOrderData = (): OrderData => ({
    auftrag: EmptyOrder(),
    kostenStelle: undefined,
    start: '', end: '',
    total: 0,
    spesen: EmptyExpense(),
    menge: 0,
    betrag: '',
    notizen: '',
    scanData: '',
});
